export default {
    accessibilityIssues: state => state.issues
  }
  